import { type FC } from "react";
import { Button } from "@root/shared/components/Button";
import { ClientSelectSection } from "@userFrontend/features/report/components/ClientSelectSection";
import { Infomation } from "./uiParts/Infomation";
import { ViolationType } from "./uiParts/ViolationType";
import { EmailConfirmation } from "./uiParts/EmailConfirmation";
import { DocumentSubmissionCheck } from "./uiParts/DocumentSubmissionCheck";
import { PersonInCharge } from "./uiParts/PersonInCharge";
import { type PresentationProps } from "./type";
import * as styles from "./styles.css";

export type Props = PresentationProps;

export const Presentation: FC<Props> = ({
  violationTypeProps,
  clientSelectSectionProps,
  documentSubmissionCheckProps,
  emailConfirmationProps,
  personInChargeProps,
  onSubmit,
  isSubmitting,
}) => {
  return (
    <div className={styles.wrapper}>
      {/* 冒頭の注意書き */}
      <Infomation />
      {/* 違反行為の疑いがある行為は何か */}
      <ViolationType {...violationTypeProps} />
      {/* 対象企業の選択 */}
      <ClientSelectSection {...clientSelectSectionProps} />
      {/* 担当者情報 */}
      <PersonInCharge {...personInChargeProps} />
      {/* 違反行為に関する資料の提出可否 */}
      <DocumentSubmissionCheck {...documentSubmissionCheckProps} />
      {/* 連絡先の確認 */}
      <EmailConfirmation {...emailConfirmationProps} />
      {/* 送信ボタン */}
      <hr className={styles.hr} />
      <div className={styles.submitButtonWrapper}>
        <Button
          type="button"
          theme="primary"
          className={styles.submitButton}
          onClick={onSubmit}
          disabled={isSubmitting}
        >
          違反行為を報告する
        </Button>
      </div>
    </div>
  );
};
